import { createContext, useContext } from 'react';
import { useQuery } from '@apollo/client';
import { loader } from 'graphql.macro';
import { ReportModels } from '../utilities/reports';
import { useOnlineStatus } from '../hooks/offline-hooks/offline-misc';
import { useCurrentUser } from './UserProvider';

const labelQuery = loader('./LabelProvider.graphql');

const LabelProviderContext = createContext();
export const LabelProvider = ({ children }) => {
  const online = useOnlineStatus();
  const { syncing } = useCurrentUser();
  const { data: { labels = [] } = {} } = useQuery(labelQuery, {
    skip: !online || syncing,
  });

  const models = ReportModels({ labels });

  return (
    <LabelProviderContext.Provider value={{ labels, models }}>
      {children}
    </LabelProviderContext.Provider>
  );
};
export const useLabels = () => useContext(LabelProviderContext);
